import { Injectable } from '@angular/core';
import { MapsService } from '../maps/maps.service';

@Injectable({
  providedIn: 'root',
})
export class TitleCopyService {
  copy: string;
  regex: RegExp;

  constructor(private mapsService: MapsService) {
    this.copy = '_Copy_';
    this.regex = /^(.+_Copy_)(\d+)$/;
  }

  getCopyFromTitle(from: string): string {
    const onlyTitle = from.split(this.copy)[0];

    const sameTitleCopies: string[] = this.mapsService.titles.filter((t) => {
      const title = String(t);
      return title.includes(onlyTitle) && title.match(this.regex);
    });

    let newIndex = 1;
    if (sameTitleCopies.length) {
      let starting: string;

      const sortedTitles = [...sameTitleCopies].sort((similarA, similarB) => {
        const endingA = +similarA.split(this.copy)[1];
        const endingB = +similarB.split(this.copy)[1];
        return endingA - endingB;
      });

      sortedTitles.forEach((similar) => {
        starting = similar.split(this.copy)[0];
        const ending = +similar.split(this.copy)[1];

        if (ending && ending === newIndex) {
          newIndex++;
        } else {
          return;
        }
      });

      return `${starting}${this.copy}${newIndex}`;
    }

    return `${onlyTitle}${this.copy}${newIndex}`;
  }

  getPossibleName(from: string) {
    if (this.mapsService.titleExists(from)) {
      return this.getCopyFromTitle(from);
    }
    return from;
  }
}
